import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Api from '../../Apis/api.service'
import {
  ConvocationsActions,
  ConvocationsContent,
  ConvocationsHeader,
} from './partials'

const Convocations = () => {
  const { id } = useParams()
  const [informations, setInformations] = useState(null)
  const [convocations, setConvocations] = useState([])
  const [isSyncing, setIsSyncing] = useState(false)
  const [isRecipientPreview, setIsRecipientPreview] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(async () => {
    getConvocations()
  }, [])

  const getConvocationInformations = async (id, loadRecipients = false) => {
    const res = await Api.ags.getConvocationInformations(id)
    if (res.status == 200) {
      setInformations(res.data)
      if (res.data?.order_id) {
        await syncAthomeRecipients(res.data.order_id)
      } else if (loadRecipients && !res.data?.convocation_triggered_at) {
        await getConvocationRecipients()
      }
    } else {
      setInformations(null)
    }
    if (loadRecipients) setIsLoading(false)
  }

  const syncAthomeRecipients = async (orderId) => {
    try {
      setIsSyncing(true)
      const syncRes = await Api.athome.syncRecipients(orderId)

      if (syncRes?.status === 200) {
        await getConvocations()
      }
    } catch (error) {
      console.error('Erreur lors de la synchronisation Athome:', error)
    } finally {
      setIsSyncing(false)
    }
  }
  useEffect(async () => {
    getConvocationInformations(id, true)
  }, [id])

  const getConvocations = async () => {
    const res = await Api.ags.getConvocations(id)
    if (res.status == 200) {
      setIsRecipientPreview(false)
      setConvocations(res.data)
    } else {
      setConvocations([])
    }
  }

  const getConvocationRecipients = async () => {
    const res = await Api.ags.getConvocationRecipients(id)
    if (res.status == 200) {
      setIsRecipientPreview(true)
      setConvocations(res.data)
    }
  }

  const refresh = async () => {
    await getConvocations()
    await getConvocationInformations(id)
  }

  return (
    <>
      <ConvocationsHeader
        id={id}
        informations={informations}
        refresh={async () => {
          await refresh()
        }}
      />
      <ConvocationsActions
        id={id}
        informations={informations}
        refresh={async () => {
          await refresh()
        }}
      />
      <ConvocationsContent
        id={id}
        convocations={convocations}
        isSyncing={isSyncing}
        isRecipientPreview={isRecipientPreview}
        isLoading={isLoading}
      />
    </>
  )
}
export default Convocations
